import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { User } from '../../user/model/user';
import { UserService } from '../../user/service/user.service';
import { Appointment, Schedule } from '../../appointment/model/appointment';
import { AppointmentService } from '../../appointment/service/appointment.service';
import { ActivatedRoute } from '@angular/router';
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as $ from 'jquery';
import * as moment from 'moment';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.css']
})
export class AppointmentsComponent implements OnInit {
  isBooked: boolean = false;
  isPending: boolean = false;
  isMissed: boolean = false;
  isDoctor: boolean = false;
  isBda: boolean = false;
  isAll: boolean = false;
  appointments : Appointment[];
  Users : User[];
  private sub: any;
  startDate: string ="";
  endDate: string = "";
  user : any ; 
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  start: Object  = {};
  end: Object  = {};
  option: string = 'All';
  constructor(private _sharedService: SharedService, private route :ActivatedRoute,private _usrService : UserService, private _appSrv: AppointmentService) {
    let d = new Date();
    this.start =  d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
    this.end =  d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
   
   }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    if(this.user=== undefined || this.user=== null) {
      this.getUserDetail('');
    }
    this.Users=[];
    var id : any;
    let d = new Date();
     this.startDate=  d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
    this.endDate= d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
    
    this.sub = this.route.params.subscribe(params => {     
      if(params.hasOwnProperty('id')) {
        id = params['id']; 
        if(id=="doctor") {
          this.isDoctor = true;
          this.isBda = false;
          this.isPending = false;
          this.isBooked = false;
          this.isAll = false;
          this.isMissed = false;
          this.getUser();
        } else if(id=="bda") {
          this.isBda = true;
          this.isDoctor = false;
          this.isPending = false;
          this.isBooked = false;
          this.isAll = false;
          this.isMissed = false;
          this.getBda();
        } else if(id=="pending") {
          this.isPending = true;
          this.isBooked = false;
          this.isBda = false;
          this.isDoctor = false;
          this.isAll = false;
          this.isMissed = false;
         this.getAllPendingAppointment(this.startDate, this.endDate);
        } else if(id=="booked") {
          this.isBooked = true;
          this.isPending = false;
          this.isBda = false;
          this.isDoctor = false;
          this.isAll = false;
          this.isMissed = false;
          this.getAllCompletedAppointment(this.startDate, this.endDate);
        } else if(id=="missed") {
          this.isMissed = true;
          this.isPending = false;
          this.isBda = false;
          this.isDoctor = false;
          this.isAll = false;
          this.isBooked = false;
          this.getAllMissedAppointment(this.startDate, this.endDate);
        } else if(id=="all") {
          this.isAll = true;
          this.isBooked = false;
          this.isPending = false;
          this.isBda = false;
          this.isDoctor = false;
          this.isMissed = false;
          this.getAllAppointment(this.startDate, this.endDate);
        }
      } 
   });
  }
  exportDocInExcel() {
    this.exportAsExcelFile(this.Users,"ExpertList");
  }
  exportBdaInExcel() {
    this.exportAsExcelFile(this.Users,"BdaList");
  }
  exportPendingInExcel() {
    this.exportAsExcelFile(this.appointments,"Pending Appointment");
  }
  exportCompletedInExcel() {
    this.exportAsExcelFile(this.appointments,"Completed Appointment");
  }
  exportMissedInExcel() {
    let app: any = this.appointments;
    if(this.user.UserRoleId !=1)
    {
      app =JSON.parse(JSON.stringify(this.appointments));
      app.forEach(function(currentItem) {
        delete currentItem["IsPatientAvailable"];
        delete currentItem["Refund"];
     });
    }
    this.exportAsExcelFile(app,"Missed Appointment");
  }
  exportAllInExcel() {
    this.exportAsExcelFile(this.appointments,this.option);
  }
  exportAsExcelFile(json: any, excelFileName: string): void {
    //const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    //const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(json, excelFileName);
  }

  saveAsExcelFile(items: any, type: string)
  {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(items[0]);
    let csv = items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    csv = csv.join('\r\n');

    //Download the file as CSV
    var downloadLink = document.createElement("a");
    var blob = new Blob(["\ufeff", csv]);
    var url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = type+".csv";  //Name the file here
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  
  private saveAsExcelFile1(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName  + EXCEL_EXTENSION);
  }
  getUser() {
    this.Users= [];
    this._usrService.getUsers().subscribe(data=>{
     
      this.Users  = data.filter(item=> item.UserRoleId==1 || item.UserRoleId==2);

    },
    error=>{
       
    });
  }
  getBda() {
    this.Users = [];
    this._usrService.getUsers().subscribe(data=>{
     
      this.Users  = data.filter(item=> item.UserRoleId==4);

    },
    error=>{
       
    });
  }
  
  getAllUpcomingAppointment(startdate: string, enddate: string) {
    this._appSrv.getAllUpcomingAppointment(startdate,enddate).subscribe(data=>{
     
      this.appointments = data;

    },
    error=>{
       
    });
  }
  getAllPendingAppointment(startdate: string, enddate: string) {
    this._appSrv.getAllPendingAppointment(startdate,enddate).subscribe(data=>{
     
      this.appointments = data;

    },
    error=>{
       
    });
  }
  showData() {
    this.appointments = [];
    if(this.option=='All') {
      
      if(this.startDate !="" && this.endDate !="") {
        this.getAllAppointment(this.startDate, this.endDate);
      }
    } else if(this.option=='Pending') {
      this.showPendingList();
    } else if(this.option=='Upcoming') {
      this.showUpcomingList();
    } else if(this.option=='Missed') {
      this.showUpcomingList();
    } else {
      this.showCompletedList();
    }
  }
  getAllAppointment(startdate: string, enddate: string) {
    this._appSrv.getAllAppointment(startdate,enddate ).subscribe(data=>{
     
       this.appointments = data;

    },
    error=>{
       
    });
  }
  showCompletedList() {
     
    if(this.startDate !="" && this.endDate !="") {
      this.getAllCompletedAppointment(this.startDate, this.endDate);
    }
    
  }


  showMissedList() {
     
    if(this.startDate !="" && this.endDate !="") {
      this.getAllMissedAppointment(this.startDate, this.endDate);
    }
    
  }

  showPendingList() {
    let stratDate = $('#startdate').val();
    let endDate  = $('#enddate').val();
     
    if(this.startDate !="" && this.endDate !="") {
    this.getAllPendingAppointment(this.startDate, this.endDate)
    }
  }
  showUpcomingList() {
     
    if(this.startDate !="" && this.endDate !="") {
    this.getAllUpcomingAppointment(this.startDate, this.endDate)
    }
  }
  getAllCompletedAppointment(startdate: string, enddate: string) {
    this._appSrv.getAllCompletedAppointment(startdate,enddate ).subscribe(data=>{
     
       this.appointments = data;

    },
    error=>{
       
    });
  }

  getAllMissedAppointment(startdate: string, enddate: string) {
    this._appSrv.getAllMissedAppointment(startdate,enddate ).subscribe(data=>{
     
       this.appointments = data;

    },
    error=>{
       
    });
  }

 ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  onDateChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      this.startDate= event.date.year + '-' + event.date.month + '-'+ event.date.day;
    }
    else {
      this.startDate="";
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }
  onDateEndChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      this.endDate= event.date.year + '-' + event.date.month + '-'+ event.date.day;
    }
    else {
      this.endDate = "";
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }
  getUserDetail(startDate: string) {
    this._usrService.getUserProfile().subscribe(data=>{
       if(data.length>0) {
       
        this.user = data[0];
        sessionStorage.setItem("User",JSON.stringify(data[0]));
        
      }
      
    },error => {
       
    })
  }
cancel(){
  console.log('ok');
}

}



// WEBPACK FOOTER //
// ./src/app/section/report/appointments/appointments.component.ts